/* eslint-disable max-lines */
import React from 'react';
import {connect} from 'react-redux';
import {Button, Card} from 'semantic-ui-react';
import {handleExcelFloatingReport} from '../../utils/commonUtils';
import '../main/modalOrderInfo/styles.scss';

const HeaderReport = ({filteredData, titles, isUserTde, dealerId}) => {
  const handleExportExcel = () => {
    const excelRows = filteredData.map((row) => {
      return row.original;
    });
    handleExcelFloatingReport(excelRows, titles, {isUserTde, dealerId});
  };
  return (
    <Card fluid className='no-space'>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <h3>
            Reporte de inventario flotante
          </h3>
          <div className="title-bar-actions">
            <Button
              primary
              color='red'
              onClick={handleExportExcel}
              disabled={!filteredData?.length}
            >
              EXPORTAR
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default connect(null, {})(HeaderReport);
